export function parseTranscript(transcript) {
  if (!transcript) return []

  const lines = transcript.split('\n')
  const messages = []

  for (const line of lines) {
    const trimmedLine = line.trim()

    if (!trimmedLine ||
        trimmedLine.startsWith('[') ||
        trimmedLine.startsWith('{') ||
        trimmedLine.startsWith('<function:')) {
      continue
    }

    if (trimmedLine.startsWith('aimee:')) {
      messages.push({
        text: trimmedLine.substring(6).trim(),
        isAimee: true
      })
    } else if (trimmedLine.startsWith('patient/speaker:')) {
      messages.push({
        text: trimmedLine.substring(16).trim(),
        isAimee: false
      })
    } else if (trimmedLine.startsWith('user:')) {
      messages.push({
        text: trimmedLine.substring(5).trim(),
        isAimee: false
      })
    }
  }

  return messages
}

export function getMessageCount(transcript) {
  const messages = parseTranscript(transcript)
  return messages.length
}

export function getConversationPreview(transcript, maxMessages = 2, maxLength = 40) {
  const messages = parseTranscript(transcript)
  
  if (messages.length === 0) return ['No valid messages']

  return messages.slice(0, maxMessages).map(message => {
    const speaker = message.isAimee ? 'Aimee' : 'Patient'
    const text = message.text.length > maxLength 
      ? message.text.substring(0, maxLength) + '...' 
      : message.text
    return `${speaker}: ${text}`
  })
} 